import { Observable, of } from "rxjs";
import { BaseFlowComponent } from "../base-flow-component/base-flow-component";
import { CompleteActivitySavingResultData } from "./complete-activity-saving-result.data";
import { Component } from "@angular/core";
import { ActivitiesService } from "../../../../services/activities.service";

@Component({
    selector: 'complete-activity-saving-result',
    templateUrl: './complete-activity-saving-result.component.html',
    styleUrls: ['./complete-activity-saving-result.component.scss']
})
export class CompleteActivitySavingResultComponent extends BaseFlowComponent<CompleteActivitySavingResultData> {
    
    constructor( ) {
        super();
    }

    initData() { }
    
    saveChanges(): Observable<any> {
        return of({ });
    }
}